import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'FinalizedCombi' })
export class FinalizedCombTansform implements PipeTransform {
    transform(value: number): string {
        return value == 1 ? 'Yes' : 'No'
    }; 
}